import { useState, useEffect } from 'react';
import validateForm from '../utility/validateForm';

const useForm = (initialState: any, initialDirty: any) => {
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [dirtyObj, setDirtyObj] = useState(initialDirty);
    const [isError, setErrorStatus] = useState(false);
    const reset = () => {
        setValues(initialState);
        setErrors({});
        setDirtyObj(initialDirty);
        setErrorStatus(false);
    };

    const updateDirtyObj = (name: any) => {
        setDirtyObj((data: any) => ({ ...data, [name]: true }));
    };

    const handleValueChange = (name: any, value: any) => {
        setValues((data: any) => ({ ...data, [name]: value }));
        updateDirtyObj(name);
    };

    useEffect(() => {
        const { formErrors, errorStatus } = validateForm(
            values,
            dirtyObj,
        );
        setErrors(formErrors);
        setErrorStatus(errorStatus);
    }, [values, dirtyObj]);

    return {
        values,
        errors,
        isError,
        handleValueChange,
        setDirtyObj,
        reset,
    };
};

export default useForm;
